export default __webpack_public_path__ + "static/financial-year-scam-0f3396c7064382a14c6ec917915cd3f5.webp";